module.exports = __webpack_public_path__ + "static/media/khoi-3d-round.40d46969.jpg";